module.exports = __webpack_public_path__ + "static/media/new-category-icon.798f6268.svg";